import state from './moduleDrugbookState.js';
import mutations from './moduleDrugbookMutations.js';
import actions from './moduleDrugbookActions.js';
import getters from './moduleDrugbookGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
